import Questions, { Question, DEFAULT } from './Questions';

export default Questions;
export { Question, DEFAULT };
